import { Link, Text } from '@customerio/pluma-components/react';
import { useWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';
import { generatePath } from '@/services/router/generate-path';

/**
 * Subtle inline link to the old Ember dashboard page.
 * Passes ?legacy to prevent the Ember route from redirecting back.
 */
export function LegacyDashboard() {
  const workspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;

  return (
    <Text size="xs" color="subtle">
      Miss the classic dashboard?{' '}
      <Link
        href={generatePath('/workspaces/:workspaceId/journeys/dashboard', { workspaceId }, { legacy: '' })}
        variant="primary"
        icon="chevron-right"
        iconPosition="trailing"
      >
        It's still here
      </Link>
    </Text>
  );
}
